import { render, staticRenderFns } from "./VariableEditModal.vue?vue&type=template&id=7980c47b"
import script from "./VariableEditModal.vue?vue&type=script&lang=js"
export * from "./VariableEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports